import { IconAngleLeft, IconAngleRight } from '@maia/icons';
import { ActionButton } from '../../atoms/actionButton/actionButton';
import { Typography } from '../../atoms/typography/typography';
import { PaginationStyles, paginationStyles } from './variants';
import { Select } from '../../ui';

type Props = {
  totalPages: number;
  page: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: 10 | 20 | 50) => void;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  limit: number;
} & PaginationStyles;

const LIMIT_OPTIONS = [
  {
    label: '10',
    value: '10',
    meta: {},
  },
  {
    label: '20',
    value: '20',
    meta: {},
  },
  {
    label: '50',
    value: '50',
    meta: {},
  },
] as const;

export function Pagination(props: Props) {
  const {
    page,
    totalPages,
    limit,
    hasPreviousPage,
    hasNextPage,
    onPageChange,
    onLimitChange,
    variant,
  } = props;

  return (
    <div className={paginationStyles({ variant })}>
      <div className="flex items-center gap-x-12">
        <ActionButton
          icon={IconAngleLeft}
          onPress={() => onPageChange(page - 1)}
          isDisabled={!hasPreviousPage}
        />
        <Typography
          variant="body-s"
          weight="regular"
          className="text-grayscale300"
        >
          {page} van {totalPages || 1}
        </Typography>
        <ActionButton
          icon={IconAngleRight}
          onPress={() => onPageChange(page + 1)}
          isDisabled={!hasNextPage}
        />
      </div>
      <div className="flex items-center gap-x-24">
        <Typography
          variant="body-s"
          weight="regular"
          className="text-grayscale300"
        >
          Resultaten per pagina
        </Typography>
        <Select
          size="small"
          items={LIMIT_OPTIONS}
          onChange={(value) =>
            onLimitChange(parseInt(value.toString()) as 10 | 20 | 50)
          }
          value={limit.toString()}
        />
      </div>
    </div>
  );
}
